import {SurveySectionsRenderingModel} from "data/models/survey/base";
import {TITLE_CLASS} from "components/Survey/classes";

export const BrandTraitsTitle = ({businessName}: SurveySectionsRenderingModel) => (
    <span className={TITLE_CLASS}>{businessName} brand traits.</span>
);
